export default __webpack_public_path__ + "static/media/NeueMontreal-Bold.2c3ec94b.woff2";